import { useGoogleLogin } from '@react-oauth/google';
import google from "../assets/image/google.png";
import axios from 'axios';
import axiosInstance from '../utils/axios';
import { Form, message } from 'antd';
import { useNavigate } from "react-router-dom";
import { useCookies } from 'react-cookie';
import { useEffect } from 'react';
import logo from "../assets/icon/logo.png"

export default function Login() {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [cookies, setCookie, removeCookie] = useCookies(["user"]);

    const user = JSON.parse(localStorage.getItem("user"));

    const loginGmail = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            const response = await axios.get('https://www.googleapis.com/oauth2/v2/userinfo', {
                headers: {
                    Authorization: `Bearer ${tokenResponse.access_token}`,
                },
            });

            if (response.data) {
                response.data.access_token = tokenResponse.access_token;
                await axiosInstance.post('/user/loginGmail', response.data)
                    .then((res) => {
                        if (res?.data?.status === 1) {

                            const loginUser =
                                res?.data?.data?.[0];

                            if (loginUser?.token) {
                                localStorage.setItem(
                                    "user_token",
                                    loginUser.token
                                );

                                localStorage.setItem(
                                    "token",
                                    loginUser.token
                                );
                            }

                            setCookie(
                                "user",
                                loginUser
                            );

                            localStorage.setItem(
                                "user",
                                JSON.stringify(loginUser)
                            );

                            message.success(
                                "Đăng nhập thành công!"
                            );

                            navigate(-1);
                        }
                    })
                    .catch((error) => {
                        message.error(error?.message || "Đăng nhập Gmail thất bại");
                    })
            } else {
                message.error("Đăng nhập thất bại!");
            }
        },
        onError: (error) => {
            console.error('Login Failed:', error);
        },
    });

    const onSubmit = async (data) => {
        await axiosInstance.post('/user/login', data)
            .then(async (res) => {
                message.success(String(res?.data?.message));
                if (res?.data?.status === 1) {

                    const loginUser =
                        res?.data?.data?.[0];

                    if (loginUser?.token) {
                        localStorage.setItem(
                            "user_token",
                            loginUser.token
                        );

                        localStorage.setItem(
                            "token",
                            loginUser.token
                        );
                    }

                    setCookie(
                        "user",
                        loginUser
                    );

                    localStorage.setItem(
                        "user",
                        JSON.stringify(loginUser)
                    );

                    navigate(-1);
                }
            })
            .catch((error) => {
                message.error(error?.message || "Tài khoản hoặc mật khẩu không đúng");
            })
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (user) {
            navigate("/");
        }
    }, [user]);

    return (
        <section className="min-h-screen bg-[#f6f8fc] dark:bg-gray-900 flex items-start md:items-center justify-center px-4 pt-[39px] pb-24 md:py-12">

            <div className="w-full max-w-[430px]">

                <div className="bg-white dark:bg-gray-800 rounded-[22px] md:rounded-[28px] border border-gray-100 dark:border-gray-700 shadow-[0_12px_35px_rgba(15,23,42,0.08)] px-5 py-6 md:px-8 md:py-8">

                    {/* TITLE */}
                    <div className="text-center mb-6">

                        <h1 className="text-[26px] md:text-[28px] font-bold text-gray-900 dark:text-white leading-tight mb-2">
                            Đăng nhập
                        </h1>

                        <p className="text-[14px] text-gray-500 dark:text-gray-400 m-0">
                            Đăng nhập tài khoản để tiếp tục
                        </p>

                    </div>


                    {/* EMAIL / PASSWORD - UU TIEN */}
                    <Form
                        layout="vertical"
                        colon={false}
                        form={form}
                        onFinishFailed={(e) => console.log(e)}
                        onFinish={onSubmit}
                    >

                        <Form.Item
                            label={
                                <span className="text-[14px] font-semibold text-gray-700 dark:text-gray-300">
                                    Email
                                </span>
                            }
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: "Vui lòng nhập Email!"
                                }
                            ]}
                            className="!mb-4"
                        >
                            <input
                                type="email"
                                autoComplete="email"
                                className="w-full box-border px-4 py-3.5 rounded-xl border border-gray-200 dark:border-gray-600 bg-[#f8fafc] dark:bg-gray-700 text-[15px] text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                                placeholder="Nhập email của bạn"
                            />
                        </Form.Item>


                        <Form.Item
                            label={
                                <span className="text-[14px] font-semibold text-gray-700 dark:text-gray-300">
                                    Mật khẩu
                                </span>
                            }
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: "Vui lòng nhập mật khẩu!"
                                }
                            ]}
                            className="!mb-2"
                        >
                            <input
                                type="password"
                                autoComplete="current-password"
                                className="w-full box-border px-4 py-3.5 rounded-xl border border-gray-200 dark:border-gray-600 bg-[#f8fafc] dark:bg-gray-700 text-[15px] text-gray-900 dark:text-white outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                                placeholder="Nhập mật khẩu"
                            />
                        </Form.Item>


                        <div className="flex justify-end mb-5">

                            <a
                                href="/quen-mat-khau"
                                className="text-[13px] font-semibold text-blue-600 hover:text-blue-700"
                            >
                                Quên mật khẩu?
                            </a>

                        </div>


                        <button
                            type="submit"
                            className="w-full min-h-[52px] rounded-xl bg-[#2563eb] hover:bg-[#1d4ed8] active:scale-[0.99] text-white text-[16px] font-bold transition-all shadow-sm"
                        >
                            Đăng nhập
                        </button>

                    </Form>


                    {/* DIVIDER */}
                    <div className="relative my-6">

                        <div className="absolute inset-0 flex items-center">
                            <div className="w-full border-t border-gray-200 dark:border-gray-700" />
                        </div>

                        <div className="relative flex justify-center">

                            <span className="px-3 bg-white dark:bg-gray-800 text-[12px] text-gray-400">
                                hoặc
                            </span>

                        </div>

                    </div>


                    {/* GOOGLE - PHU */}
                    <button
                        type="button"
                        onClick={() => loginGmail()}
                        className="w-full min-h-[52px] px-4 rounded-xl border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 active:scale-[0.99] transition-all flex items-center justify-center"
                    >

                        <img
                            src={google}
                            alt="Google"
                            className="w-5 h-5 object-contain mr-3"
                        />

                        <span className="text-[15px] font-semibold text-gray-800 dark:text-gray-100">
                            Tiếp tục với Google
                        </span>

                    </button>


                    {/* REGISTER */}
                    <div className="mt-6 pt-5 border-t border-gray-100 dark:border-gray-700 text-center">

                        <span className="text-[13px] text-gray-500 dark:text-gray-400">
                            Chưa có tài khoản?
                        </span>

                        <a
                            href="/dang-ky"
                            className="ml-1.5 text-[13px] font-bold text-blue-600 hover:text-blue-700"
                        >
                            Đăng ký ngay
                        </a>

                    </div>


                    <p className="mt-4 text-center text-[11px] leading-5 text-gray-400">
                        Bạn cũng có thể đăng nhập nhanh bằng Google.
                    </p>

                </div>

            </div>

        </section>
    )
}
